import { Box,Button,Flex,Select,InputGroup,
  InputLeftElement,Input, Text, 
  TableContainer,Table,Thead,Tbody,Th,Tr,Td,Grid,GridItem } from "@chakra-ui/react";
import { TopDisplay } from "../../../../components";
import { IoMdAdd as AddIcon } from "react-icons/io";
import { LuSearch as SearchIcon } from "react-icons/lu";
import { useState,useEffect } from "react";
import { useMutation, useQuery, useQueryClient } from 'react-query';
import styled from "@emotion/styled";
import { atom, useAtom } from 'jotai';
import apiCall from '../../../../utils/apiCall';
import {TopLink} from '../';
import {openAtom,modalAtom,openNAtom,notificationAtom} from '../../../../context';
import { Formik,Form,Field } from "formik";
import {TablePopUp} from '../../../../components';
import * as Yup from 'yup';
import { Loader } from "../../../../customs";
import ReactPaginate from 'react-paginate';
import { TbReload as ReloadIcon } from "react-icons/tb";


const HeadStyle={
  borderBottom:"1px solid var(--dark-green-color)",
  padding:'15px 5px',
}
const DataStyle = {
  padding:'5px 5px',
}


const ROWSTYLE = styled.tr`
  & > td:last-of-type > *{
    display:none;
  }
  :hover > td{
    background-color:var(--table-highlight);
    &:last-of-type > *{
      display:block;
    }
  } 
  &.active > td:last-of-type > *{
    display:block !important;
  }  
`

const SubscriptSetUpAtom = atom<number | null>(null);


export default function SubscriptSetUp() {
  const [, set_modal] = useAtom(modalAtom);
  const [, set_open] = useAtom(openAtom);
  const [active] = useAtom<number | null>(SubscriptSetUpAtom);

  const [search, set_search] = useState('');
  const [filterData, setFilterData] = useState<any[]>([]);
  const [itemOffset, setItemOffset] = useState(0);

  const itemsPerPage = 10;

  const { isLoading, data: allSubscriptSetUp = [] } = useQuery({
    queryKey: ['subscription-setup'],
    queryFn: async () =>
      (await apiCall().get(`/MembershipSetUp/member/GetAllfeesetup?targetedMembersId=3`)).data.Data,
  });

  useEffect(() => {
    setFilterData(allSubscriptSetUp);
  }, [allSubscriptSetUp]);

  const handleAddSubscription = () => {
    set_modal({
      header: 'Student Subscription Setup',
      content: <AddType />,
    });
    set_open(true);
  };

  const handleSearch = (e: any) => {
    const value = e.target.value.toLowerCase();
    set_search(value);
    setItemOffset(0);

    if (!value) {
      setFilterData(allSubscriptSetUp);
      return;
    }

    const filtered = allSubscriptSetUp.filter((item: any) =>
      Object.values(item).join(' ').toLowerCase().includes(value)
    );

    setFilterData(filtered);
  };

  const endOffset = itemOffset + itemsPerPage;
  const currentItems = filterData.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filterData.length / itemsPerPage);

  const handlePageClick = (event: any) => {
    setItemOffset(event.selected * itemsPerPage);
  };


  return (
    <>
    {isLoading?<Loader />:
    <Box>
      <TopLink />
      <TopDisplay label="Student Subscription SetUp" button_array={[
          <Button onClick={handleAddSubscription} bg="var(--dark-green-color)" color="var(--white-color)"  type="button"  leftIcon={<AddIcon/>}>Add Student Subscription</Button>
        ]} />
        <Flex  gap="20px" wrap="wrap" mt="20px">
          <InputGroup width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
            <InputLeftElement pointerEvents='none'>
              <SearchIcon color='gray.300' />
            </InputLeftElement>
            <Input value={search} onChange={handleSearch} type='text' placeholder='search' />
            <span style={{position:'absolute',zIndex:'1',
            right:'10px',cursor:'pointer',top:'12px'}}><ReloadIcon /></span>
          </InputGroup>
          
        </Flex>
        <Flex mt="25px" flexDir="column" gap="10px">
 <Text fontSize="sm" mt="10px">
            Showing {itemOffset + 1} - {Math.min(endOffset, filterData.length)} of{' '}
            {filterData.length}
          </Text> 
          </Flex>
     {  filterData.length > 0 ?<TableContainer mt="20px">
          <Table size='sm'>
            <Thead>
              <Tr >
                {/* <Th sx={HeadStyle}>Exam ID</Th> */}
                <Th sx={HeadStyle}>Payment Form</Th>
                <Th sx={HeadStyle}>MembershipType Name</Th>
                <Th sx={HeadStyle}>Amount</Th>
                <Th sx={HeadStyle}>IsActive</Th>
                <Th sx={HeadStyle} w="50px"></Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentItems.map((eExamSuject:any) =><ROWSTYLE key={eExamSuject.Id} className={eExamSuject.Id === active?'active':''}>
                {/* <Td sx={DataStyle}>{eExamSuject.Id}</Td> */}
                <Td sx={DataStyle}>{eExamSuject.PaymentForm}</Td>
                <Td sx={DataStyle}>{eExamSuject.MembershipTypeName}</Td>
                <Td sx={DataStyle}>{eExamSuject.Amount}</Td>
                <Td sx={DataStyle}>{eExamSuject.IsActive ? 'Yes' : 'No'}</Td>
                <Td sx={DataStyle} w="50px" h="50px">
                  <TempPopUp index={eExamSuject.Id} data={eExamSuject}/>
                </Td>
              </ROWSTYLE>
              )}
            </Tbody>
          </Table>
        </TableContainer>
        :'No Subscription SetUp Found'  
      }
      <StylePaginateBox>
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
        />

       </StylePaginateBox>
    </Box>
    }
    </>
    
  )
}
const StylePaginateBox = styled.div`
  width:100%;
  & > ul{
    list-style-type: none;
    text-align:center;
    padding:0;
    margin:0;
    margin-top:10px;
  } 
  & > ul > li{
    display: inline;
    margin:0 5px;
    padding:2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color:var(--dark-green-color);
  }
  & > ul > li.selected{
    background-color: var(--highlight-paginate-background);
    color:var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type{
    font-weight: bold;
  }
`

const AddSchema = Yup.object({
  PaymentForm:Yup.string().required(),
  MembershipType:Yup.number().required(),
  MembershipTypeName:Yup.string().required(),
  IsActive:Yup.string().required(),
  Amount:Yup.number().required(),
});

const AddType = (props: any) => {
  const queryClient = useQueryClient();
  const [, set_open] = useAtom(openAtom);
  const [, set_Nopen] = useAtom(openNAtom);
  const [, set_notification] = useAtom(notificationAtom);

const isEdit = Boolean(props?.Id);

const { mutate: addUpdate, isLoading } = useMutation({
    mutationKey: ['new-subscription-setup'],
    mutationFn: async (data: any) =>
      apiCall().post(`/MembershipSetUp/member/feesetup`, data),

    onSuccess(res) {
      set_notification({
        type: 'success',
        message: res?.data?.Message || 'Subscription saved successfully',
      });
      queryClient.invalidateQueries({ queryKey: ['subscription-setup'] });
      set_Nopen(true);
    },

    onError() {
      set_notification({
        type: 'error',
        message: 'Error occurred',
      });
      set_Nopen(true);
    },

    onSettled() {
      set_open(false);
    },
  });

  return (
    <Formik
      enableReinitialize
   initialValues={{
      MembershipType: 4,
      MembershipTypeName: 'Student',
      PaymentForm: 'Subscription',
      Amount: props?.Amount ?? '',
      IsActive: Boolean(props?.IsActive),
    }}


      validationSchema={AddSchema}
    onSubmit={(values) => {
      const payload: any = {
      PaymentForm: 'Subscription',
      MembershipType: 4,
      MembershipTypeName: 'student',
      Amount: Number(values.Amount),
      IsActive: values.IsActive,
    };

    // Only add Id if editing
    if (isEdit) {
      payload.Id = props.Id;
    }

    addUpdate(payload);
      }}


    >
      {({ errors, touched, setFieldValue }) => (
        <Form>
          <Flex flexDir="column" gap="20px">

            {/* Membership Name */}
            <Box>
              <label>Membership Type</label>
              <Field
                as={Input}
                name="MembershipTypeName"
                borderColor="green"
                isDisabled
                bg="gray.100"
              />
            </Box>

            {/* Payment Form */}
            <Box>
              <label>Payment Form</label>
              <Field
                as={Input}
                boderColor="green"
                name="PaymentForm"
                isDisabled
                bg="gray.100"
              />
            </Box>

            {/* Amount */}
            <Box>
              <label>Amount</label>
              <Field
                as={Input}
                boderColor="green"
                name="Amount"
                type="number"
                borderColor="green"
              />
              {errors.Amount && touched.Amount && (
                <Text color="red.500" fontSize="sm">
                  {typeof errors.Amount === 'string' ? errors.Amount : ''}
                </Text>
              )}
            </Box>

            {/* Status */}
            <Box>
              <label>Status</label>
            <Field
            as={Select}
            boderColor="green"
            name="IsActive"
            onChange={(e: any) =>
              setFieldValue('IsActive', e.target.value === 'true')
            }
          >
            <option value="true">true</option>
            <option value="false">false</option>
          </Field>


            </Box>

            <Button
              type="submit"
              isDisabled={isLoading}
              bg="var(--dark-green-color)"
              color="white"
            >
              {isLoading
                ? 'Saving...'
                : isEdit
                ? 'Update Subscription'
                : 'Add Subscription'}
            </Button>
          </Flex>
        </Form>
      )}
    </Formik>
  );
};




const TempPopUp = (props:any) =>{
  const index = props.index;
  const data = props.data;
  const [active,set_active] = useAtom(SubscriptSetUpAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_modal] = useAtom(modalAtom);
  const [,set_Nopen] = useAtom(openNAtom);
  const [,set_notification]= useAtom(notificationAtom);
  const queryClient = useQueryClient();
  const {mutate:deleteFee,isLoading} = useMutation({
    mutationKey:['delete-subscription-set-up'],
    mutationFn:async () => await apiCall().get(`/MembershipSetUp/Member/feesetup/${data?.Id}/delete`),
    onSuccess(data:any) {
      queryClient.invalidateQueries({queryKey:["subscription-setup"]})
      set_notification({
        type:'success',
        message:data?.data?.Message || 'Subscriptionfees Deleted Successfully'
      })
      set_Nopen(true);
    },
    onSettled(){
      set_open(false);
    }
  })

  const handleClick = () =>{
    if(index === active){
      set_active(null);
      return;
    }
    else{
      set_active(index);
    }
  }
  const handleView= () =>{
    set_modal({
      header:'View Subscription SetUp',
      content:<Grid>
        <GridItem justify="space-between" p="10px 0" as={Flex}>
          {/* <span>Subject Id</span>
          <span>{data?.Id}</span> */}
        </GridItem >
        <GridItem as={Flex} justify="space-between" p="10px 0">
          <span>Membership Type Name:</span>
          <span>{data?.MembershipTypeName}</span>
        </GridItem>
        <GridItem as={Flex} justify="space-between" p="10px 0">
          <span>Payment Form</span>
          <span>{data?.PaymentForm}</span>
        </GridItem>
        <GridItem as={Flex} justify="space-between" p="10px 0">
          <span>Amount</span>
          <span>{data?.Amount}</span>
        </GridItem>
        <GridItem as={Flex} justify="space-between" p="10px 0">
          <span>IsActive</span>
          <span>{data?.IsActive ? 'Yes' : 'No'}</span>
        </GridItem>
      </Grid>
    })
    set_open(true);
    handleClick();
  }
 const handleEdit = () => {
  set_active(index);

  set_modal({
    header: 'Edit Subscription SetUp',
    content: <AddType {...data} />, // ✅ data contains Id, Amount, IsActive
  });

  set_open(true);
};

  const handleDelete = () =>{
    set_modal({
      header:'Delete Subscription SetUp',
      content:<Grid gap="20px">
        <GridItem>Are you Sure you want to delete this Subscription setUp</GridItem>
        <GridItem as={Flex} justify="space-between" p="20px 0">
          <Button disabled={isLoading} onClick={()=>deleteFee()} bg="var(--dark-green-color)"
            color="var(--white-color)" >{isLoading?'Loading':'Delete'}</Button>
          <Button disabled={isLoading} 
            variant="outline" bg="var(--white-color)"
            onClick={()=>set_open(false)}
            border="1px solid var(--dark-green-color)"
            color="var(--dark-green-color)" >Cancel</Button>
        </GridItem>
      </Grid>
    });
    set_open(true);
  }
  
  return (
    <TablePopUp click={handleClick} options={[
      {label:'View Subsc.SetUp',click:handleView},
      {label:'Edit Subsc.SetUp',click:handleEdit},
      // {label:'Delete Subscription SetUp',click:handleDelete}
    ]} />
  )
}

